import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { API_URL, ICarrierConfigDto } from '@/dtos';
import { ClaimAutopayType } from '@/modules/employee/employee.types';

import {
  CarrierConfig,
  CarrierConfigPurpose,
  ConfigStatus,
} from '../../types/carrier.types';

const formatCarrierConfig = (carrierConfig: ICarrierConfigDto): CarrierConfig => ({
  id: toString(carrierConfig.id),
  carrier: {
    id: toString(carrierConfig?.carrier?.id),
    name: carrierConfig?.carrier?.name || '',
    externalId: carrierConfig?.carrier?.external_id || '',
  },
  submitterId: carrierConfig?.submitter_id || '',
  description: carrierConfig?.description || '',
  organizationId: toString(carrierConfig.organization_id),
  organizationPath: carrierConfig.organization_path || '',
  serviceDateFrom: carrierConfig?.service_date_from as unknown as string,
  serviceDateTo: carrierConfig?.service_date_to as unknown as string,
  purposeType: carrierConfig.purpose_type as unknown as CarrierConfigPurpose,
  // TODO: this field doesn't exists in the DTO
  // @ts-ignore
  claimPaymentMethod: carrierConfig.claim_payment_method,
  isDependentDeidentified: carrierConfig.is_dependent_deidentified || false,
  isDependentAutocreated: carrierConfig.is_dependent_autocreated || false,
  statusType: carrierConfig.status_type as unknown as ConfigStatus,
  claimPayeeType: carrierConfig.claim_payee_type || '',
  amountTypes: carrierConfig.amount_types as string[],
  claimAutopayType: carrierConfig.claim_autopay_type as unknown as ClaimAutopayType,
});

const useCarrierConfigQuery = (carrierId: string) => {
  const { isLoading, isSuccess, isError, data } = useQuery(
    [API_URL.CARRIER_CONFIGS_BY_ID(carrierId)],
    () => api.get(API_URL.CARRIER_CONFIGS_BY_ID(carrierId)),
    { enabled: !!carrierId }
  );

  return {
    formattedData: data?.data ? formatCarrierConfig(data?.data) : undefined,
    data,
    isLoading,
    isSuccess,
    isError,
  };
};

export default useCarrierConfigQuery;
